<template>
  <div id="item_shop">
    <van-nav-bar
      :title="document_title"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-button type="default" round size="small" @click="onClickRight">{{ $t('column.My_props') }}</van-button>
      </template>
    </van-nav-bar>
    <van-row class="item_shop">
      <van-col span="24" class="item_shop_list_height">
        <van-col span="22" offset="1" class="item_shop_list_center">
          <van-row gutter="20">
            <van-col span="8" v-for="(t,j) in car" :key="j" @click.native="shop_show_btn(t,1)" style="padding-left: 10px!important;">
              <van-col span="24" class="item_shop_list_center_one">
                <van-col span="24" class="item_shop_list_center_one_img">
                  <img :src="t.img"/>
                </van-col>
                <van-col span="24" class="item_shop_list_center_one_title">{{ t.name }}</van-col>
                <van-col span="24" class="item_shop_list_center_one_coin">
                  <img :src="coin_img"/>
                  <span>{{ t.coin }}/{{ t.day }} {{ $t('other.days') }}</span>
                </van-col>
                <van-col span="20" class="item_shop_list_center_one_svip" v-if="discount_rate">
                  <van-tag color="#ff3a31">{{ svip_title }} - {{ discount_rate }}%</van-tag>
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-col>
      </van-col>
      <van-popup v-model="shop_show" round position="bottom" :style="{ minHeight: '40%' }" >
        <van-col span="22" offset="1" class="item_shop_popup_title">
          <van-col span="22" offset="1" class="item_shop_popup_title_name">{{ buy_one.name }}</van-col>
          <van-col span="22" offset="1" class="item_shop_popup_title_day">{{ $t('column.Valid_live_days') }} {{ buy_one.day }} {{ $t('other.days') }}</van-col>
        </van-col>
        <van-col span="24" class="item_shop_popup" @click.native="car_play(buy_one.svga)">
          <van-icon name="play-circle-o" class="item_shop_popup_icon"/>
          <img :src="buy_one.img"/>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_popup_price_area">
          <van-row gutter="10">
            <van-col span="12">
              <div :class="discount_rate > 0 ? 'price_card standard_price' : 'price_card item_shop_popup_vip_price'">
                <div class="price_label">{{ $t('other.standard_price') }}</div>
                <div class="price_value">
                  <img :src="coin_img"/>
                  <span>{{ buy_one.coin }}</span>
                </div>
                <div class="save_amount"></div>
              </div>
            </van-col>
            <van-col span="12" v-if="discount_rate > 0">
              <div class="price_card item_shop_popup_vip_price">
                <div class="price_label">{{ svip_title }} <van-tag color="#ff3a31"> - {{ discount_rate }}%</van-tag></div>
                <div class="price_value">
                  <img :src="coin_img"/>
                  <span>{{ buy_one.vip_coin || Math.floor(buy_one.coin * (100 - discount_rate) / 100) }}</span>
                </div>
                <div class="save_amount" v-if="discount_rate">{{ $t('btn.save_coin') }}: <img :src="coin_img"/> {{ Math.floor(buy_one.coin * discount_rate / 100) }}</div>
              </div>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_popup_btn">
          <van-button round color="#AE2CF1" block  @click="car_btn"> {{ buy_one.is_renew ?  buy_one.time + ' ' + this.$t('other.expire') +',' + this.$t('Tips.Whether_to_renew') : $t('btn.purchase') }}</van-button>
        </van-col>
      </van-popup>
      <van-overlay :show="svgaShow" @click.native="svgaHide" class="car_svga_index">
        <div id="svgaBox" @click.stop="svgaHide"></div>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
import SVGA from "svgaplayerweb";
export default {
  data() {
    return {
      document_title: '',
      car: [],
      svgaShow: false,
      shop_show: false,
      buy_one: {},
      coin_img: '',
      is_submit: true,
      head_image: '',
      svip_title: '',
      discount_rate: '',
    }
  },
  created: function() {
    this.convert();
    this.document_title = this.$t('column.Car')
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    popup_popular_svga() {
      const val = this.buy_one
      console.log('dddddd')
      console.log(val)
      this.$nextTick(()=>{
        //这里动态给ID，列表
        const player1 = new SVGA.Player('#popup_popular_svga' + val.id);
        const parser1 = new SVGA.Parser('#popup_popular_svga' + val.id);
        console.log(val.img)
        //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
        parser1.load(val.img, function(videoItem1) {
          player1.setVideoItem(videoItem1);
          player1.startAnimation();
        })
      })
    },
    shop_show_btn(t,type) {
      this.buy_one = t
      this.buy_one.pay_id = 0;
      this.buy_one.time = 0;
      this.buy_one.is_renew = 0;
      this.buy_one.shop_type = type; // 1座驾 2头像框
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=select_coin", {
        params: {
          user_id: uid,
          token: token,
          id: this.buy_one.id,
          type: type
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.buy_one.time = res.data.list.time
          this.buy_one.pay_id = res.data.list.id
          this.buy_one.is_renew = res.data.list.is_renew;
          this.shop_show = true
          if(this.buy_one.shop_type === 2){
            this.popup_popular_svga()
          }
        } else {
          Toast(res.data.error)
        }
      })
    },
    svgaHide() {
      this.svgaShow = false
    },
    car_btn() {
      if (this.is_submit === false) {
        return false
      }
      this.is_submit = false
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=pay", {
        params: {
          user_id: uid,
          token: token,
          id: this.buy_one.pay_id,
          shop_id: this.buy_one.id,
          shop_type: this.buy_one.shop_type == 1 ? -1 : 0
        }
      }).then(res => {
        this.is_submit = true
        console.log(res.data)
        this.shop_show = false
        Toast(res.data.error)
      })
    },
    car_play(url) {
      this.svgaShow = true
      const _this= this
      this.$nextTick(() => {
        try {
          const player = new SVGA.Player('#svgaBox');
          const parser = new SVGA.Parser('#svgaBox');
          //注意，这里必须是服务器地址，否则报错
          parser.load(url, function(videoItem) {
            player.loops = 1;  // 设置循环播放次数是1
            player.setVideoItem(videoItem);
            player.startAnimation();
            player.onFinished(function(){
              _this.svgaShow = false
            });
          })
        } catch (error) {
          console.error(error);
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1); // 返回上一页
    },
    onClickRight() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/item_shop_my', query: {uid: uid, token: token}})
    },
    convert() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=car_list", {
        params : {
          user_id: uid,
          token: token
        }
      }).then(res =>{
        console.log(res.data)
        this.car = res.data.data.list
        this.diamonds_name = res.data.data.diamonds_name
        this.coin_img = res.data.data.consumer_price_Icon
        this.svip_title = res.data.data.svip_title
        this.discount_rate = res.data.data.discount_rate
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/item_shop_car.vue